import React, { Component } from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  href?: string;
  className?: string;
}
export function Button({
  children,
  href = '#oferta',
  className = '',
  ...props
}: ButtonProps) {
  const Component = motion.a;
  return <Component href={href} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`
        inline-flex items-center justify-center gap-2
        bg-[#F9A8B7] hover:bg-[#EC8FA1] text-white
        font-bold text-lg md:text-xl py-4 px-8
        rounded-full shadow-[0_8px_20px_rgba(249,168,183,0.4)]
        transition-colors duration-300 w-full md:w-auto
        ${className}
      `} {...props as any} data-id="element-185">
      {children}
      <ArrowRightIcon className="w-6 h-6" data-id="element-186" />
    </Component>;
}